import { render, staticRenderFns } from "./favorite-products-list.vue?vue&type=template&id=1f475bf4&scoped=true&"
import script from "./favorite-products-list.ts?vue&type=script&lang=ts&"
export * from "./favorite-products-list.ts?vue&type=script&lang=ts&"
import style0 from "./favorite-products-list.scss?vue&type=style&index=0&id=1f475bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f475bf4",
  null
  
)

export default component.exports